export default __webpack_public_path__ + "static/media/icon-trashcan-zulage.c029e378.svg";